import React from "react";
import { useTranslation } from 'react-i18next';

import "./isolated-styles.css";
import CloseCaixaForm from "../../Forms/CloseCaixaForm";
import { IoMdLock } from "react-icons/io";

const CloseCaixaModal = ({ onClose }) => {
  const { t } = useTranslation('cashRegister');

  return (
    <div className="close-caixa-modal-container">
      <div className="modern-modal-header">
        <h1 className="modern-modal-title">
          <IoMdLock />
          {t('closeCaixa.modalTitle')}
        </h1>
        <p className="modern-modal-subtitle">
          {t('closeCaixa.modalSubtitle')}
        </p>
      </div>
      <div className="modal-form" style={{margin:10}}>
        <CloseCaixaForm onClose={onClose} />
      </div>
    </div>
  );
};

export default CloseCaixaModal;
